const STORAGE_KEY = 'tendera:upgrade-intent';

const SOURCE_LABELS = {
    sidebar_pricing: 'sidebar pricing card',
    sidebar_opportunities: 'procurement opportunities',
    sidebar_market_data: 'market data',
    home_activate_all_features: 'home PRO unlock',
    home_smallscale: 'small-scale notices',
    home_opportunities: 'opportunity detection',
    search_profile_limit: 'profile limit',
    search_ai_assistant: 'AI search assistant',
    search_source_system: 'data source filters',
    search_locked_result: 'locked search result',
    search_pro_banner: 'search PRO banner',
    profile_locked_result: 'locked profile result',
    tender_ai_assistant: 'tender AI assistant',
    tender_criteria_export: 'tender criteria export',
    market_data_upsell: 'market data upsell',
    ai_assistant_upsell: 'AI assistant upsell',
    decisions_ai_chat_upsell: 'decisions AI chat upsell',
};

export const createUpgradeContext = (source, details = {}) => {
    if (!source) return null;
    const path = typeof window !== 'undefined'
        ? `${window.location.pathname}${window.location.search || ''}`
        : undefined;

    return {
        source,
        path,
        feature: details.feature,
        noticeId: details.noticeId,
        sourceSystem: details.sourceSystem,
        openedAt: new Date().toISOString(),
    };
};

export const normalizeUpgradeContext = (context) => {
    if (!context) return null;
    if (typeof context === 'string') {
        return createUpgradeContext(context);
    }
    if (typeof context === 'object' && context.source) {
        return {
            ...createUpgradeContext(context.source),
            ...context,
            openedAt: context.openedAt || new Date().toISOString(),
        };
    }
    return null;
};

export const persistUpgradeIntent = (context) => {
    const normalized = normalizeUpgradeContext(context);
    if (!normalized || typeof window === 'undefined') return normalized;

    try {
        const value = JSON.stringify(normalized);
        window.sessionStorage.setItem(STORAGE_KEY, value);
        window.localStorage.setItem(STORAGE_KEY, value);
    } catch (error) {
        console.warn('Failed to persist upgrade context', error);
    }

    return normalized;
};

export const getStoredUpgradeIntent = () => {
    if (typeof window === 'undefined') return null;

    try {
        const raw = window.sessionStorage.getItem(STORAGE_KEY) || window.localStorage.getItem(STORAGE_KEY);
        return raw ? normalizeUpgradeContext(JSON.parse(raw)) : null;
    } catch (error) {
        console.warn('Failed to read upgrade context', error);
        return null;
    }
};

export const clearStoredUpgradeIntent = () => {
    if (typeof window === 'undefined') return;

    try {
        window.sessionStorage.removeItem(STORAGE_KEY);
        window.localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
        console.warn('Failed to clear upgrade context', error);
    }
};

export const appendUpgradeParams = (url, context) => {
    const normalized = normalizeUpgradeContext(context);
    if (!normalized) return url;

    url.searchParams.set('upgrade_source', normalized.source);
    if (normalized.feature) url.searchParams.set('upgrade_feature', normalized.feature);
    if (normalized.sourceSystem) url.searchParams.set('upgrade_source_system', normalized.sourceSystem);
    if (normalized.noticeId) url.searchParams.set('upgrade_notice_id', normalized.noticeId);
    if (normalized.path) url.searchParams.set('upgrade_path', normalized.path);
    return url;
};

export const getUpgradeContextLabel = (t, context) => {
    const normalized = normalizeUpgradeContext(context);
    if (!normalized) return '';
    const fallback = SOURCE_LABELS[normalized.source] || normalized.source;
    return t?.(`upgradeContext.sources.${normalized.source}`, fallback) || fallback;
};

export const getUpgradeContextMessage = (t, context) => {
    const label = getUpgradeContextLabel(t, context);
    if (!label) return '';
    return t?.('upgradeContext.modalMessage', {
        source: label,
        defaultValue: `You opened this PRO upgrade from: ${label}.`
    }) || `You opened this PRO upgrade from: ${label}.`;
};
